export default {
	TitleNotification: 'Thiết lập thông báo',
	ReceiveEmailNotificationSetup: 'Nhận email thông báo hóa đơn thay đổi trạng thái',
	GuideLabel: 'Hướng dẫn',
	Edit: 'Sửa',
	TitleSettingNavbar: 'Thiết lập hiển thị thanh phân hệ',
	ReceiveSettingNavbar: 'Thiết lập hiển thị các phân hệ theo nhu cầu sử dụng',
	SettingNavbarDetail: {
		Title: 'Tùy chọn hiển thị thanh phân hệ',
		TitleTable: "Danh sách phân hệ",
		dashboard: "Tổng quan",
		invoice: "Hóa đơn đầu vào",
		invoiceThirdParty: "Hóa đơn", // PBI-546507: Cho org đặc thù
		outinvoice: "Hóa đơn đầu ra",
		customsdeclaration: "Tờ khai hải quan",
		inboxmanagement: "Hộp thư",
		supplier: "Danh mục",
		organization: "Cơ cấu tổ chức",
		connectinvoices: "Kết nối nhà cung cấp",
		connecttaxaxions: "Kết nối Cơ quan thuế",
		report: "Báo cáo",
		system: "Hệ thống",
		knowledge: "Kiến thức hữu ích",
	},
	SettingFilterDate: {
		TitleSettingFilterDate: "Thiết lập mặc định lọc ngày trên danh sách hóa đơn đầu vào",
		TitleSettingFilterDateThirdParty: "Thiết lập mặc định lọc ngày trên danh sách hóa đơn", // PBI-546507: Cho org đặc thù
		SettingDate: 'Theo Ngày hóa đơn',
		SettingDateEenteredTheSystem: 'Theo Ngày vào hệ thống',
	},
	SettingAppearance: {
		Title: 'Thiết lập màu sắc giao diện',
		Description: 'Thiết lập màu nền hiển thị cho Sidebar và Tiêu đề trang',
		GroupTitlebar: 'Chọn màu thanh tiêu đề',
		GroupSidebar: 'Chọn màu sidebar',
		OptionTitlebarApp: 'Màu ứng dụng',
		OptionTitlebarWhite: 'Màu trắng',
		OptionSidebarDark: 'Màu tối',
		OptionSidebarWhite: 'Màu trắng',
		Reset: 'Lấy lại mặc định'
	}
};
